<template>
  <div class="bb-timer-control" @click.stop>
    <div
      class="bb-timer-control__item"
      @click="onButtonStop"
    >
      <div v-html="StopIcon()"/>
    </div>
    <div
      class="bb-timer-control__item"
      @click="onOpenModal"
    >
      {{counter}}
    </div>
    <div class="bb-timer-control__dash"/>
    <div
      class="bb-timer-control__item"
      :class="[
       disabled && 'bb-timer-control__item_disabled'
      ]"
      @click="onButtonPause"
    >
      <div v-html="isShowActiveIcon ? PauseIcon() : PlayIcon()"/>
    </div>
    <div
      class="bb-timer-control__item"
      @click="onButtonDelete"
    >
      <div v-html="DeleteIcon()"/>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow
        v-if="isShowDeleteModal"
        customWrapperClass="bb-modal-wrapper_min-padding"
        buttonRightName="YES"
        :isFooter="true"
        @close="isShowDeleteModal = false"
        @handlerClick="deleteTimer"
      >
        <TimerDeleteModal />
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import {DeleteIcon, PauseIcon, StopIcon, PlayIcon} from '@/constants/icon'
import {TIMER_STATUS} from '@/constants/timerStatus'
import {REMINDER_STATUS} from '@/constants/recurReminders'
import TimerApi from '@/api/Timer/api'
import moment from 'moment'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'
import TimerDeleteModal from '@/components/Main/TimerControl/TimerDeleteModal'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'

export default {
  name: 'TimerControl',
  components: {
    TimerDeleteModal,
    ModalWindow
  },
  mixins: [convertSecondsToTime],
  data: () => ({
    DeleteIcon,
    StopIcon,
    PauseIcon,
    PlayIcon,
    imerID: null,
    isShowDeleteModal: false
  }),
  computed: {
    disabled () {
      const { subTimers = {} } = this.activeTimer
      const { status } = subTimers
      return TIMER_STATUS.COMPLETED === status
    },
    time: {
      get () {
        return this.$store.getters.time
      },
      set (data) {
        this.$store.dispatch('setTimer', data)
      }
    },
    isStart: {
      get () {
        return this.$store.getters.isStart
      },
      set (data) {
        this.$store.dispatch('setStart', data)
      }
    },
    isPause: {
      get () {
        return this.$store.getters.isPause
      },
      set (data) {
        this.$store.dispatch('setPause', data)
      }
    },
    activeTimer: {
      get () {
        return this.$store.getters.activeTimer
      },
      set (data) {
        this.$store.dispatch('setActiveTimer', data)
      }
    },
    isShowTimerPanel: {
      get () {
        return this.$store.getters.isShowTimerPanel
      },
      set (data) {
        this.$store.dispatch('setShowTimer', data)
      }
    },
    isShowTimerModalFinance: {
      get () {
        return this.$store.getters.isShowTimerModalFinance
      },
      set (data) {
        this.$store.dispatch('setShowTimerModalFinance', data)
      }
    },
    counter () {
      const { hours, minutes, seconds } = this.time
      return `${hours}:${minutes}:${seconds}`
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    isShowActiveIcon () {
      const { subTimers = {} } = this.activeTimer
      const { status = 0 } = subTimers
      const { ACTIVE } = TIMER_STATUS
      return status === ACTIVE
    },
    isProjectTimer () {
      const { instanceStatus } = this.activeTimer
      return REMINDER_STATUS.PROJECT === instanceStatus
    },
    isSubproject () {
      const { subprojectId, subTimers = {} } = this.activeTimer
      const { isSub = false } = subTimers
      return subprojectId && isSub
    },
    isHourProject () {
      const { subprojectId, subTimers = {} } = this.activeTimer
      const { isSub = false } = subTimers
      return subprojectId && !isSub
    }
  },
  methods: {
    onOpenModal () {
      const { project, requestProject } = this.activeTimer
      this.isShowTimerModalFinance = this.isProjectTimer ? project : requestProject
      this.isShowTimerPanel = false
    },
    onButtonStop () {
      const { COMPLETED } = TIMER_STATUS
      const { subTimers = {} } = this.activeTimer
      const { status = 4 } = subTimers
      this.onOpenModal()
      if (status === COMPLETED) return
      this.completeTimer()
      this.addCurrentStatusActiveTimer(COMPLETED)
    },
    async completeTimer () {
      const {
        project,
        requestProject,
        subprojectId,
        subTimers = {},
        instanceStatus
      } = this.activeTimer

      const body = {
        user: this.userInfo ? this.userInfo.id : '5f8097e4e06d0800124c7a5d',
        endDate: this.time.fullDate,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus,
        subTimerId: subTimers._id,
        ...this.body
      }
      try {
        await TimerApi.completeTimer(body)
      } catch (err) {
        console.error(err)
      }
    },
    onButtonPause () {
      this.isPause = !this.isPause
      if (this.isPause) {
        this.createTimer()
      } else {
        this.pauseTimer()
      }
    },
    onButtonDelete () {
      this.isShowDeleteModal = !this.isShowDeleteModal
    },
    addCurrentStatusActiveTimer (status) {
      const { subTimers = {} } = this.activeTimer
      subTimers.status = status
    },
    async createTimer () {
      this.addCurrentStatusActiveTimer(TIMER_STATUS.ACTIVE)
      const {
        project,
        requestProject,
        subprojectId,
        subTimers = {},
        instanceStatus
      } = this.activeTimer

      const body = {
        user: this.userInfo.id,
        startDate: new Date(),
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus,
        subTimerId: subTimers._id
      }
      try {
        const { data } = await TimerApi.createTimer(body)
        const { _id } = data
        this.activeTimer = {
          ...this.activeTimer,
          _id
        }
      } catch (err) {
        console.error(err)
      }
    },
    async pauseTimer () {
      if (!this.isPause) this.addCurrentStatusActiveTimer(TIMER_STATUS.PAUSE)
      const {
        project,
        requestProject,
        subprojectId,
        subTimers = {},
        instanceStatus
      } = this.activeTimer

      const body = {
        user: this.userInfo.id,
        endDate: this.time.fullDate,
        project: this.isProjectTimer ? subprojectId ? [project, subprojectId] : [project] : undefined,
        request: this.isProjectTimer ? undefined : [requestProject],
        instanceStatus,
        subTimerId: subTimers._id
      }
      try {
        const { data } = await TimerApi.pauseTimer(body)
        const { _id } = data
        this.activeTimer = {
          ...this.activeTimer,
          subTimers: {
            ...subTimers,
            _id
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async deleteTimer () {
      this.isShowDeleteModal = false
      this.isStart = !this.isStart
      const { subTimers = {} } = this.activeTimer
      const { _id } = subTimers
      try {
        await TimerApi.deleteTimer(_id)
        this.time = {
          ...this.time,
          hours: '00',
          minutes: '00',
          seconds: '00'
        }
        clearTimeout(this.timerID)
        this.activeTimer = {
          ...this.activeTimer,
          subTimers: {}
        }

        this.isShowTimerPanel = false
      } catch (err) {
        console.error(err)
      }
    },
    defaultTime () {
      const { subTimers = {} } = this.activeTimer
      const { timeSteps = [] } = subTimers
      const newArray = timeSteps.map((el) => moment(el.endDate).unix() - moment(el.startDate).unix())
      const secondsTotal = newArray.reduce((total, current) => total + current)
      const { hours, minutes, seconds } = this.convertSecondsToTime(secondsTotal)
      this.time = {
        ...this.time,
        hours: hours.toString().padStart(2, '0'),
        minutes: minutes.toString().padStart(2, '0'),
        seconds: seconds.toString().padStart(2, '0'),
        isFirst: undefined
      }
    },
    updateTime () {
      const {year, month, date, hours, minutes, seconds} = this.time
      const cd = new Date(year, month, date, hours, minutes, seconds)
      this.time = {
        year,
        month,
        date,
        hours: this.zeroPadding(cd.getHours(), 2),
        minutes: this.zeroPadding(cd.getMinutes(), 2),
        seconds: this.zeroPadding(cd.getSeconds() + 1, 2),
        fullDate: new Date()
      }
    },
    zeroPadding (num, digit) {
      let zero = ''
      for (let i = 0; i < digit; i++) {
        zero += '0'
      }
      return (zero + num).slice(-digit)
    },
    changeStatusTimer (status) {
      const { PAUSE, ACTIVE } = TIMER_STATUS
      if (status === PAUSE) {
        this.isStart = false
        this.isPause = false
      } else if (status === ACTIVE) {
        this.isStart = false
        this.isPause = true
      } else {
        this.isStart = true
        this.isPause = true
      }
    }
  },
  watch: {
    start (newVal) {
      if (!newVal) {
        this.timerID = setInterval(this.updateTime, 1000)
        return
      }
      clearTimeout(this.timerID)
      this.time = {
        ...this.time,
        hours: '00',
        minutes: '00',
        seconds: '00'
      }
    },
    isPause (newVal) {
      const { subTimers = {} } = this.activeTimer
      const { status = 0 } = subTimers
      if (newVal && status && status !== TIMER_STATUS.COMPLETED) {
        this.timerID = setInterval(this.updateTime, 1000)
        return
      }
      clearTimeout(this.timerID)
    }
  },
  mounted () {
    const { isFirst } = this.time
    if (isFirst) this.defaultTime()
    const { subTimers = {} } = this.activeTimer
    const { status = 0 } = subTimers
    this.changeStatusTimer(status)
    if (TIMER_STATUS.ACTIVE === status) {
      this.timerID = setInterval(this.updateTime, 1000)
    }
  },
  beforeDestroy () {
    clearTimeout(this.timerID)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

.bb-timer-control {
  position: fixed;
  right: 40px;
  bottom: 30px;
  display: grid;
  grid-template-columns: 24px minmax(65px, max-content) 1px 24px 24px;
  grid-gap: 0 8px;
  min-width: 153px;
  height: 43px;
  padding: 8px;
  border-radius: 8px;
  background: $color-denim;
  z-index: 100;

  &__item {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: 0.15s;
    font-size: 14px;
    font-weight: 700;
    color: $color-white;

    &_disabled {
      pointer-events: none;
    }
  }

  &__dash {
    height: 27px;
    width: 1px;
    background: $color-wild-sand;
  }
}

</style>

<style lang="scss">

  .bb-timer-control__item svg {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/TimerControl/TimerControl.vue